import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from 'styled-components';

// Shared components
import { StyledHeading, IconBadge, ImageTag } from '../../sharedComponents';
import DownloadModuleFooter from '../innerComponents/DownloadModuleFooter';

// Constants
import { DS } from '../constants';

// Styles
import { Thumbnail } from '../styles';

const LandscapeDisplayStyle = (props) => {
  const {
    section: {
      image: { path },
      title,
      titleSize,
      alt,
    },
  } = props;

  const themeConfig = useContext(ThemeContext);
  const {
    contentGrid,
    thumbnailGrid: { xs, sm, md },
  } = themeConfig.module.dStyles;

  return (
    <div className="container">
      <div className="row">
        <div
          className={`col-xs-${xs} col-sm-${sm} col-md-${md}`}
          data-testid={`file-download-${DS.LANDSCAPE}`}
        >
          <Thumbnail>
            <ImageTag
              displayStyles={themeConfig.module.dStyles}
              src={path}
              imgixParams="w=550"
              alt={alt}
            />
            <IconBadge
              iconID="get_app"
              displayStyles={themeConfig.module.dStyles}
            />
          </Thumbnail>
          <StyledHeading
            visualStyles={themeConfig.module.vStyles}
            displayStyles={themeConfig.module.dStyles}
            content={title}
            as={titleSize}
          />
        </div>
        <div
          className={`col-xs-${contentGrid.xs} col-sm-${contentGrid.sm} col-md-${contentGrid.md}`}
        >
          <DownloadModuleFooter {...props.section} />
        </div>
      </div>
    </div>
  );
};

LandscapeDisplayStyle.propTypes = {
  section: PropTypes.shape({
    image: PropTypes.shape({
      path: PropTypes.string,
    }),
    title: PropTypes.string,
    titleSize: PropTypes.string,
  }).isRequired,
};

LandscapeDisplayStyle.defaultProps = {
  section: {
    image: {},
  },
};

export default LandscapeDisplayStyle;
